import { SavingState } from '@common/Common';
import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import EditableValueSeriesSheet from '@common/Components/EditableValueSeriesSheet.vue';
import SaveButton from '@common/Components/SaveButton.vue';
import ValueSeriesTable from '@Quest/_Common/Components/ValueSeriesTable.vue';
import { ICommandBase } from '@Quest/cqrs';
import ResourcesCommands from "@Quest/Resources/Domain/commands-vue-component";
import ResourcesQueries from "@Quest/Resources/Domain/queries-vue-component";
import { ResourceUnitCostsReadModel } from '@Quest/Resources/Domain/readmodels';
import { UpdateResourceUnitCostsCommandV1 } from '@Quest/Strategies/Domain/commands-core';
import StrategiesCommands from '@Quest/Strategies/Domain/commands-vue-component';
import { Component, mixins } from 'vue-facing-decorator';
import { Route } from 'vue-router';


@Component({
    components: { CorporateNavigation, SaveButton, ValueSeriesTable, EditableValueSeriesSheet }
})
export default class ResourceUnitCostsPage extends mixins(ResourcesQueries, ResourcesCommands, StrategiesCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: ResourceUnitCostsReadModel | null = null;
    isEditing: boolean = false;
    savingState: SavingState = SavingState.Saved;

    get title(): string { return `${this.rm?.Title} (${this.rm?.CurrencyLabel})`; }
    get stopEditingLabel() { return this.savingState === SavingState.Pending ? "Cancel editing" : "Back"; }
    get inputSeries() { return this.rm?.Series.filter(a => !a.IsTotal) ?? []; }

    startEditing()
    {
        this.isEditing = true;
    }

    cancelEditing() 
    {
        if (this.savingState === SavingState.Saved) 
        {
            this.isEditing = false;
        }
        else if (this.savingState === SavingState.Pending && confirm("You have unsaved changes. Are you sure you want to cancel editing?")) 
        {
            this.savingState = SavingState.Saved;
            this.isEditing = false;
        }
    }

    onDataChange()
    {
        this.savingState = SavingState.Pending;
    }

    handleSaveCommand()
    {
        const entries = (this.$refs.sheet as any).getEntriesForSave();
        this.invokeUpdateResourceUnitCostsCommandV1(this.workspaceId, this.strategyId, this.rm.FromYear, entries);
        this.savingState = SavingState.InProgress;
    }


    mounted()
    {
        document.title = "Resource unit costs | TransparentChoice";
        this.runResourceUnitCostsQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "ResourceUnitCostsReadModel")
        {
            this.rm = model as ResourceUnitCostsReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateResourceUnitCostsCommandV1.matchType(cmd))
        {
            this.runResourceUnitCostsQueryV1(this.workspaceId, this.strategyId);

            if (this.savingState === SavingState.InProgress)
            {
                this.savingState = SavingState.Saved;
            }
        }
    }

    beforeRouteLeave(to: Route, from: Route, next: (arg?: any) => void) 
    {
        if (this.savingState === SavingState.Pending) 
        {
            if (confirm("You have unsaved changes. Do you want to save them before leaving?")) 
            {
                this.handleSaveCommand();
                next();
            }
            else 
            {
                next();
            }
        }
        else 
        {
            next();
        }
    }
}